import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import { Toaster } from "sonner";
import EntryPage from "./pages/EntryPage";
import B2BvsB2CPage from "./pages/B2BvsB2CPage";
import BusinessPage from "./pages/BusinessPage";
import WomenPage from "./pages/WomenPage";
import MenPage from "./pages/MenPage";
import LegalPage from "./pages/LegalPage";
import AdminPage from "./pages/AdminPage";
import CheckoutSuccess from "./pages/CheckoutSuccess";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#1A1D24",
              color: "#FFFFFF",
              border: "1px solid #2C313D",
              borderRadius: 4,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<B2BvsB2CPage />} />
          <Route path="/privat" element={<EntryPage />} />
          <Route path="/business" element={<BusinessPage />} />
          <Route path="/women" element={<WomenPage />} />
          <Route path="/men" element={<MenPage />} />
          <Route path="/impressum" element={<LegalPage kind="impressum" />} />
          <Route path="/datenschutz" element={<LegalPage kind="datenschutz" />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
